<div class="card margin-top-0 margin-bottom-5" apply="theme" background="section">
  <!-- Título -->
  <div [ngClass]="{'no-theme': currentTheme?.tagStyle == 'no-theme'}"
    class="card-action padding-all-5 border-bottom center-all" apply="theme" tag-style="theme">
    <!-- Tooltip -->
    <a *ngIf="textTooltip" class="tooltip-hover btn-flat auto-height margin-right-5"
      style="line-height: inherit;padding: 0;text-transform: inherit;">
      <i [ngClass]="{'no-theme': currentTheme?.tagStyle == 'no-theme'}" class="material-icons fnt-13-i scale-lightness"
        apply="theme" color="theme" style="line-height: 21px;"
        (mouseover)="prettyTooltip.setTooltip(title, textTooltip, 'bottom', $event.target)"
        (mouseout)="prettyTooltip.setTooltip()">help</i>
    </a>
    <!-- Título -->
    <h6 class="title border-none fnt-15-i bld margin-top-5 center-align padding-bottom-0 margin-bottom-5 text-not-break"
      style="display:inline-block">{{title}}</h6>
  </div>
  <!-- Contenido -->
  <div class="card-content padding-all-10" apply="theme" color="body">
    <div class="row margin-all-0">
      <!-- Meta -->
      <p class="col l12 m12 s12 padding-all-0 text-not-break margin-bottom-0 fnt-10-i bld" style="text-align: right;">
        {{goal}}
      </p>
      <!-- Basrra de progreso para cumplimiento -->
      <div class="col l12 m12 s12 padding-all-0">
        <div style="position: relative;">
          <span class="badge margin-all-0 recovery-badges" [ngStyle]="{'width': (percent | setPercentage:true) + '%'}"
            [attr.data-badge-caption]="badge" style="white-space: nowrap;">{{percent}}%</span>
          <div class="progress margin-top-5 margin-bottom-5 scale-lightness" apply="theme"
            [attr.background]="percent | setAlertType:{'danger':0,'success':'end'}">
            <div class="determinate determinate-gradient" apply="theme"
              [attr.background]="percent | setAlertType:{'danger':0,'success':'end'}"
              [ngStyle]="{'width': (percent | setPercentage:true) + '%'}">
            </div>
          </div>
        </div>
      </div>
      <!-- Información complementaria -->
      <ng-container *ngFor="let item of text || []">
        <p class="col l12 s12 m12 padding-all-0 text-not-break margin-bottom-0 fnt-10-i bld"
          style="text-align: center;">
          {{item}}
        </p>
      </ng-container>
    </div>
  </div>
  <!-- Pié de página cuando el nivel de servicio no está al 100% -->
  <div class="card-action padding-all-5 border-bottom" *ngIf="showBtn">
    <div class="row margin-all-0">
      <button apply="theme" href="#modalForIncidents" (click)="showIncidents(title)" tag-style="outline-theme"
        class="waves-effect mouse-action-theme-waves btn btn-small txt-not-break col l6 m8 s10 offset-s1 offset-m2 offset-l3 modal-trigger mouse-action-tag-style-theme-focus"
        mouse-action="tag-style-theme-hover" apply="theme">Ver</button>
    </div>
  </div>
</div>